import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";

import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    IconButton,
    Tooltip,
    Typography,
    Chip,
    CircularProgress,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import RouteIcon from "@mui/icons-material/Route";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import API from "../../services/api-service";

import {
    Main,
    ContenedorTitulo,
    Titulo,
} from "../TestMapa/AlcantarillaElements";

const columns = [
    {
        id: "idGateway",
        label: "ID Gateway",
        minWidth: 180,
    },
    {
        id: "sensores",
        label: "Sensores",
        minWidth: 250,
    },
    {
        id: "fechaInicio",
        label: "Fecha inicial",
        minWidth: 180,
    },
    {
        id: "fechaFin",
        label: "Fecha final",
        minWidth: 180,
    },
    {
        id: "estado",
        label: "Estado",
        minWidth: 130,
    },
    {
        id: "acciones",
        label: "Acciones",
        minWidth: 110,
    },
];

const formatearFecha = (fecha) => {
    if (!fecha) {
        return "Sin fecha";
    }

    const date = new Date(fecha);

    if (isNaN(date.getTime())) {
        return "Fecha inválida";
    }

    return date.toLocaleString("es-EC", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });
};

const Detalle = () => {
    const location = useLocation();
    const history = useHistory();
    const query = new URLSearchParams(useLocation().search);
    const obteOrganizacion = query.get("organizacion");
    const localizacion = query.get("localizacion")

    const camion = location.state?.camion || {};

    const [loading, setLoading] = useState(true);
    const [rutas, setRutas] = useState([]);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    console.log("Camión recibido en Detalle:", camion);

    useEffect(() => {
        const fetchRutas = async () => {
            try {
                setLoading(true);
                const rutas = await API.getRutasPorCamion(camion.idGateway);
                setRutas(rutas);

            } catch (error) {
                console.error(
                    "Error al obtener las rutas:",
                    error
                );

                setRutas([]);
            } finally {
                setLoading(false);
            }
        };

        if (camion.idGateway) {
            fetchRutas();
        } else {
            setRutas([]);
            setLoading(false);
        }
    }, [camion.idGateway]);

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(
            parseInt(event.target.value, 10)
        );

        setPage(0);
    };

    const handleVerRuta = (ruta) => {
        history.push("/admin/detalleruta", {
            ruta: ruta,
            camion: camion,
        });
    };

    const handleVerHistoricoCamion = (sensor, nombreCamion) => {
        console.log("entre a ver el histórico del camión", sensor)
        const url = `/admin/historico?organizacion=${obteOrganizacion}&localizacion=${localizacion}&deviceID=${sensor}&tipo=pronaca_kkm&nombre=${nombreCamion}`;

        history.push(url);
    }

    return (
        <Main>
            <Box
                sx={{
                    width: "100%",
                    maxWidth: "1400px",
                    margin: "0 auto",
                    padding: {
                        xs: "20px 15px",
                        md: "30px",
                    },
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: {
                            xs: "flex-start",
                            md: "center",
                        },
                        gap: 2,
                        mb: 3,
                        flexDirection: {
                            xs: "column",
                            md: "row",
                        },
                    }}
                >
                    <Box>
                        <ContenedorTitulo
                            sx={{
                                marginBottom: "6px",
                            }}
                        >
                            <Titulo>
                                Visualización de rutas
                            </Titulo>
                        </ContenedorTitulo>
                    </Box>
                </Box>

                <Paper
                    elevation={0}
                    sx={{
                        border: "1px solid #e5e7eb",
                        borderRadius: "16px",
                        px: { xs: 2, md: 2.5 },
                        py: 2,
                        mb: 3,
                        backgroundColor: "#ffffff",
                        transition: "all 0.2s ease",
                        "&:hover": {
                            borderColor: "#bfdbfe",
                            boxShadow: "0 4px 14px rgba(15, 23, 42, 0.06)",
                        },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 2,
                        }}
                    >
                        {/* Información del camión */}
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                                minWidth: 0,
                            }}
                        >
                            {/* Icono */}
                            <Box
                                sx={{
                                    width: 52,
                                    height: 52,
                                    minWidth: 52,
                                    borderRadius: "12px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "#eff6ff",
                                    color: "#2563eb",
                                }}
                            >
                                <LocalShippingIcon fontSize="medium" />
                            </Box>

                            {/* Datos */}
                            <Box sx={{ minWidth: 0 }}>
                                <Typography
                                    variant="caption"
                                    sx={{
                                        color: "#64748b",
                                        fontWeight: 600,
                                        display: "block",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.04em",
                                        mb: 0.25,
                                    }}
                                >
                                    Camión
                                </Typography>

                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 700,
                                        color: "#1e293b",
                                        lineHeight: 1.2,
                                    }}
                                >
                                    {camion.placa || "Sin placa"}
                                </Typography>

                                {camion.idSensor && (
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            color: "#64748b",
                                            mt: 0.5,
                                            fontSize: "0.78rem",
                                        }}
                                    >
                                        Sensor:{" "}
                                        <Box
                                            component="span"
                                            sx={{
                                                fontFamily: "monospace",
                                                color: "#475569",
                                            }}
                                        >
                                            {camion.idSensor}
                                        </Box>
                                    </Typography>
                                )}
                            </Box>
                        </Box>

                        {/* Acción */}
                        <IconButton
                            onClick={() =>
                                handleVerHistoricoCamion(
                                    camion.idSensor,
                                    camion.nombre
                                )
                            }
                            size="medium"
                            aria-label="Ver histórico del camión"
                            sx={{
                                width: 42,
                                height: 42,
                                flexShrink: 0,
                                border: "1px solid #dbeafe",
                                backgroundColor: "#eff6ff",
                                color: "#2563eb",
                                borderRadius: "10px",
                                transition: "all 0.2s ease",
                                "&:hover": {
                                    backgroundColor: "#dbeafe",
                                    borderColor: "#bfdbfe",
                                    color: "#1d4ed8",
                                    transform: "translateY(-1px)",
                                },
                            }}
                        >
                            <VisibilityIcon fontSize="small" />
                        </IconButton>
                    </Box>
                </Paper>


                <Paper
                    elevation={0}
                    sx={{
                        width: "100%",
                        overflow: "hidden",
                        border: "1px solid #e5e7eb",
                        borderRadius: "14px",
                        backgroundColor: "#ffffff",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                            padding: {
                                xs: "18px",
                                md: "20px 24px",
                            },
                            borderBottom:
                                "1px solid #e5e7eb",
                        }}
                    >
                        <Box
                            sx={{
                                width: 40,
                                height: 40,
                                borderRadius: "9px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#eef7f2",
                                color: "#2e7d32",
                            }}
                        >
                            <RouteIcon />
                        </Box>

                        <Box>
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    color: "#1f2937",
                                    fontSize: "16px",
                                }}
                            >
                                Rutas registradas
                            </Typography>

                            <Typography
                                variant="caption"
                                sx={{
                                    color: "#6b7280",
                                }}
                            >
                                Selecciona una ruta para visualizar
                                su recorrido
                            </Typography>
                        </Box>
                    </Box>

                    {loading ? (
                        <Box
                            sx={{
                                minHeight: 250,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                                gap: 2,
                            }}
                        >
                            <CircularProgress
                                size={35}
                                sx={{
                                    color: "#1976d2",
                                }}
                            />

                            <Typography
                                sx={{
                                    color: "#64748b",
                                    fontSize: "14px",
                                }}
                            >
                                Cargando rutas...
                            </Typography>
                        </Box>
                    ) : rutas.length === 0 ? (
                        <Box
                            sx={{
                                minHeight: 250,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                                gap: 1,
                                padding: 3,
                            }}
                        >
                            <RouteIcon
                                sx={{
                                    fontSize: 45,
                                    color: "#cbd5e1",
                                }}
                            />

                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    color: "#475569",
                                }}
                            >
                                No existen rutas registradas
                            </Typography>

                            <Typography
                                variant="caption"
                                sx={{
                                    color: "#94a3b8",
                                }}
                            >
                                No se encontraron rutas para este
                                camión.
                            </Typography>
                        </Box>
                    ) : (
                        <>
                            <TableContainer>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            {columns.map(
                                                (column) => (
                                                    <TableCell
                                                        key={
                                                            column.id
                                                        }
                                                        sx={{
                                                            minWidth:
                                                                column.minWidth,
                                                            backgroundColor:
                                                                "#f8fafc",
                                                            color: "#475569",
                                                            fontWeight: 700,
                                                            fontSize:
                                                                "13px",
                                                            textTransform:
                                                                "uppercase",
                                                            letterSpacing:
                                                                "0.3px",
                                                            borderBottom:
                                                                "1px solid #e2e8f0",
                                                            padding:
                                                                "15px 20px",
                                                        }}
                                                        align={
                                                            column.id ===
                                                                "acciones"
                                                                ? "center"
                                                                : "left"
                                                        }
                                                    >
                                                        {
                                                            column.label
                                                        }
                                                    </TableCell>
                                                )
                                            )}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {rutas
                                            .slice(
                                                page *
                                                rowsPerPage,
                                                page *
                                                rowsPerPage +
                                                rowsPerPage
                                            )
                                            .map(
                                                (
                                                    row,
                                                    index
                                                ) => (
                                                    <TableRow
                                                        hover
                                                        key={`${row.idGateway}-${row.fechaInicio}-${index}`}
                                                        sx={{
                                                            "&:last-child td":
                                                            {
                                                                borderBottom: 0,
                                                            },
                                                            "&:hover":
                                                            {
                                                                backgroundColor:
                                                                    "#f8fafc",
                                                            },
                                                        }}
                                                    >
                                                        <TableCell
                                                            sx={{
                                                                padding:
                                                                    "16px 20px",
                                                                borderBottom:
                                                                    "1px solid #f1f5f9",
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display:
                                                                        "flex",
                                                                    alignItems:
                                                                        "center",
                                                                    gap: 1.5,
                                                                }}
                                                            >
                                                                <Box
                                                                    sx={{
                                                                        width: 34,
                                                                        height: 34,
                                                                        borderRadius:
                                                                            "8px",
                                                                        display:
                                                                            "flex",
                                                                        alignItems:
                                                                            "center",
                                                                        justifyContent:
                                                                            "center",
                                                                        backgroundColor:
                                                                            "#f1f5f9",
                                                                        color: "#475569",
                                                                    }}
                                                                >
                                                                    <RouteIcon
                                                                        fontSize="small"
                                                                    />
                                                                </Box>

                                                                <Typography
                                                                    sx={{
                                                                        fontWeight: 600,
                                                                        fontSize:
                                                                            "14px",
                                                                        color: "#1f2937",
                                                                    }}
                                                                >
                                                                    {
                                                                        row.idGateway
                                                                    }
                                                                </Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell
                                                            sx={{
                                                                padding:
                                                                    "16px 20px",
                                                                borderBottom:
                                                                    "1px solid #f1f5f9",
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display:
                                                                        "flex",
                                                                    flexDirection:
                                                                        "column",
                                                                    gap: 0.7,
                                                                }}
                                                            >
                                                                {row.sensores?.map(
                                                                    (
                                                                        sensor
                                                                    ) => (
                                                                        <Box
                                                                            key={
                                                                                sensor.deviceID
                                                                            }
                                                                            sx={{
                                                                                display:
                                                                                    "flex",
                                                                                alignItems:
                                                                                    "center",
                                                                                gap: 1,
                                                                            }}
                                                                        >
                                                                            <Chip
                                                                                label={
                                                                                    sensor.nombre
                                                                                }
                                                                                size="small"
                                                                                sx={{
                                                                                    backgroundColor:
                                                                                        "#eef7f2",
                                                                                    color: "#2e7d32",
                                                                                    fontWeight: 600,
                                                                                    borderRadius:
                                                                                        "6px",
                                                                                }}
                                                                            />

                                                                            <Typography
                                                                                variant="caption"
                                                                                sx={{
                                                                                    color: "#64748b",
                                                                                }}
                                                                            >
                                                                                {
                                                                                    sensor.deviceID
                                                                                }
                                                                            </Typography>
                                                                        </Box>
                                                                    )
                                                                )}
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell
                                                            sx={{
                                                                padding:
                                                                    "16px 20px",
                                                                borderBottom:
                                                                    "1px solid #f1f5f9",
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display:
                                                                        "flex",
                                                                    alignItems:
                                                                        "center",
                                                                    gap: 1,
                                                                }}
                                                            >
                                                                <CalendarMonthIcon
                                                                    sx={{
                                                                        fontSize: 18,
                                                                        color: "#1976d2",
                                                                    }}
                                                                />

                                                                <Typography
                                                                    sx={{
                                                                        fontSize:
                                                                            "14px",
                                                                        color: "#374151",
                                                                    }}
                                                                >
                                                                    {formatearFecha(
                                                                        row.fechaInicio
                                                                    )}
                                                                </Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell
                                                            sx={{
                                                                padding:
                                                                    "16px 20px",
                                                                borderBottom:
                                                                    "1px solid #f1f5f9",
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    display:
                                                                        "flex",
                                                                    alignItems:
                                                                        "center",
                                                                    gap: 1,
                                                                }}
                                                            >
                                                                <CalendarMonthIcon
                                                                    sx={{
                                                                        fontSize: 18,
                                                                        color: "#64748b",
                                                                    }}
                                                                />

                                                                <Typography
                                                                    sx={{
                                                                        fontSize:
                                                                            "14px",
                                                                        color: "#374151",
                                                                    }}
                                                                >
                                                                    {formatearFecha(
                                                                        row.fechaFin
                                                                    )}
                                                                </Typography>
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell
                                                            sx={{
                                                                padding:
                                                                    "16px 20px",
                                                                borderBottom:
                                                                    "1px solid #f1f5f9",
                                                            }}
                                                        >
                                                            <Chip
                                                                label={
                                                                    row.estado ||
                                                                    "Sin estado"
                                                                }
                                                                size="small"
                                                                sx={{
                                                                    backgroundColor:
                                                                        row.estado ===
                                                                            "finalizada"
                                                                            ? "#dcfce7"
                                                                            : "#fef3c7",
                                                                    color:
                                                                        row.estado ===
                                                                            "finalizada"
                                                                            ? "#166534"
                                                                            : "#92400e",
                                                                    fontWeight: 600,
                                                                    borderRadius:
                                                                        "6px",
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell
                                                            align="center"
                                                            sx={{
                                                                padding:
                                                                    "16px 20px",
                                                                borderBottom:
                                                                    "1px solid #f1f5f9",
                                                            }}
                                                        >
                                                            <Tooltip
                                                                title="Ver detalle de la ruta"
                                                            >
                                                                <IconButton
                                                                    onClick={() =>
                                                                        handleVerRuta(
                                                                            row
                                                                        )
                                                                    }
                                                                    size="small"
                                                                    sx={{
                                                                        backgroundColor:
                                                                            "#eaf2ff",
                                                                        color: "#1976d2",
                                                                        borderRadius:
                                                                            "8px",
                                                                        width: 38,
                                                                        height: 38,
                                                                        "&:hover":
                                                                        {
                                                                            backgroundColor:
                                                                                "#d6e7ff",
                                                                            color: "#125ea8",
                                                                        },
                                                                    }}
                                                                >
                                                                    <VisibilityIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Box
                                sx={{
                                    borderTop:
                                        "1px solid #e5e7eb",
                                    backgroundColor:
                                        "#fafafa",
                                }}
                            >
                                <TablePagination
                                    component="div"
                                    count={rutas.length}
                                    page={page}
                                    onPageChange={
                                        handleChangePage
                                    }
                                    rowsPerPage={
                                        rowsPerPage
                                    }
                                    onRowsPerPageChange={
                                        handleChangeRowsPerPage
                                    }
                                    rowsPerPageOptions={[
                                        5,
                                        10,
                                        25,
                                    ]}
                                    labelRowsPerPage="Filas por página:"
                                    labelDisplayedRows={({
                                        from,
                                        to,
                                        count,
                                    }) =>
                                        `${from}-${to} de ${count !== -1
                                            ? count
                                            : `más de ${to}`
                                        }`
                                    }
                                    sx={{
                                        "& .MuiTablePagination-toolbar":
                                        {
                                            minHeight:
                                                "58px",
                                            paddingLeft: 2,
                                            paddingRight: 2,
                                        },
                                        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                                        {
                                            color: "#64748b",
                                            fontSize:
                                                "13px",
                                        },
                                    }}
                                />
                            </Box>
                        </>
                    )}
                </Paper>
            </Box>
        </Main>
    );
};

export default Detalle;
